import { core, db } from '@/store/firebase'
import { aggregate } from '@/utils/aggregations'

export default {
  async createGestationAndGestationInteraction (idPatient, user, company) {
    const gestation = await db.collection('gestations').add({
      date: new Date(),
      company: db.doc('companies/' + company),
      patient: db.doc('patients/' + idPatient)
    })

    const date = new Date()
    const studyDate = date.toISOString().substring(0, 10)

    // Dados básicos para o gestationInteraction
    const gestationInteractionData = {
      date,
      studyDate,
      gestation: db.doc('gestations/' + gestation.id)
    }

    // Adiciona informações do médico apenas se o usuário for médico
    if (user && user.role === 'doctor') {
      gestationInteractionData.resource = user.displayName
      gestationInteractionData.doctor = {
        id: user.uid,
        name: user.displayName,
        avatar: user.photoURL
      }
    }

    const gestationInteraction = await db.collection('gestationInteraction').add(gestationInteractionData)

    this.updatePatientLastInteraction(idPatient)

    return gestationInteraction
  },

  createGestationInteraction (patient, doctor, company, forms = {}, studies = {}, gestationIuid) {
    // data do exame
    let date
    if (forms['gestationalAge.info.interationDate']) {
      date = forms['gestationalAge.info.interationDate']
    } else {
      date = new Date()
      forms['gestationalAge.info.interationDate'] = date
    }
    const studyDate = date.toISOString().substring(0, 10)

    // data do aniversário do paciente
    const studyPatientBirthDate = patient.birthdate.toISOString().substring(0, 10)

    // Dados básicos que serão usados em ambos os casos
    const baseData = {
      date,
      studyDate,
      studyPatientBirthDate,
      forms,
      studies,
      company: aggregate('company', company),
      patient: aggregate('patient', patient)
    }

    // Adiciona informações do médico apenas se ele existir
    if (doctor) {
      baseData.resource = doctor.displayName
      baseData.doctor = aggregate('doctor', doctor)
    }

    // Adiciona a referência à gestação se existir
    if (gestationIuid) {
      baseData.gestation = db.doc('gestations/' + gestationIuid)
    }

    return db.collection('gestationInteraction').add(baseData)
  },

  saveGestationInteraction (giIuid, gestationIuid, patient, doctor, company, forms = {}) {
    // Dados básicos para atualização
    const updateData = {
      gestation: db.doc('gestations/' + gestationIuid),
      forms,
      company: aggregate('company', company),
      patient: aggregate('patient', patient)
    }

    // Adiciona informações do médico apenas se ele existir e for médico
    if (doctor && doctor.role === 'doctor') {
      updateData.doctor = aggregate('doctor', doctor)
    }

    return db.collection('gestationInteraction').doc(giIuid).set(updateData, { merge: true })
  },

  updatePatientLastInteraction (idPatient) {
    return db.collection('patients').doc(idPatient).update({
      timestamp: core.firestore.FieldValue.serverTimestamp()
    })
  },

  async update (payload) {
    const { iuid } = payload
    delete payload.iuid
    await db.doc('gestationInteraction/' + iuid).set(payload, { merge: true })
  },

  async getGestationInteractions (gestationIuid) {
    return db.collection('gestationInteraction')
    .where('gestation', '==', db.doc('gestations/' + gestationIuid))
    .get()
    .then(async result => {
      if (result.empty) return []
      const items = []
      result.docs.forEach(item => {
        items.push(item.id)
      })
      return items
    })
  },

  async getGestationInteractionsByDoctor (doctorId) {
    return db.collection('gestationInteraction')
    .where('doctor.id', '==', doctorId)
    .orderBy('date', 'desc')
    .limit(5)
    .get()
    .then(async result => {
      if (result.empty) return []
      const items = []
      result.docs.forEach(item => {
        items.push(item.id)
      })
      return items
    })
  }

}



// WEBPACK FOOTER //
// ./src/api/gestation.js